import { Grid, TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Typography } from '@mui/material';

export default function RofBatchVolume({ batchVolumes, selectedProject }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">
                Batch Volumes
            </Typography>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                ProjectId
                            </TableCell>
                            <TableCell align="left">
                                BatchId
                            </TableCell>
                            <TableCell align="left">
                                KilnId
                            </TableCell>
                            <TableCell align="left">
                                Gross Volume
                            </TableCell>
                            <TableCell align="left">
                                Partially Burnt Volume
                            </TableCell>
                            <TableCell align="left">
                                Net Volume
                            </TableCell>
                            <TableCell align="left">
                                Unit
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {batchVolumes?.data?.map((data, i) => {
                            const isLastIteration = i === batchVolumes.length - 1
                            return (
                                <TableRow key={i}>
                                    <TableCell align="left">{data.projectId}</TableCell>
                                    <TableCell align="left">{data.batchId}</TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>{data.kilnUsed}</TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>{data.grossVol}</TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>{data.partiallyBurntVol}</TableCell>
                                    <TableCell align="left" sx={isLastIteration ? { borderBottom: '2px solid black' } : null}>{data.netVol}</TableCell>
                                    <TableCell align="left">{selectedProject?.measureType === 'Imperial' ? <> yrd<sup>3</sup></> : <> m<sup>3</sup></>}</TableCell>
                                </TableRow>
                            );
                        })}
                        <TableRow>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left"></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>TOTAL</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{batchVolumes?.totals?.totalGrossVol}</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{batchVolumes?.totals?.totalPartiallyBurntVol}</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}><b>{batchVolumes?.totals?.totalNetVol}</b></TableCell>
                            <TableCell align="left" sx={{ border: '2px solid black' }}>{selectedProject?.measureType === 'Imperial' ? <> yrd<sup>3</sup></> : <> m<sup>3</sup></>}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
